import { Category } from './../model/search-base-model';
import { AnyAction } from 'redux';
import { SearchState, SearchStateActions } from './../model/state-models';
import { Filters } from '../model/search-base-model';

const initialState: SearchState<any> = {
  filters: {},
  currentItems: null,
  initialItems: null,
  categories: {},
  selectedItem: null,
  showDetail: false,
};


export const searchStateReducer = (state = initialState, action: AnyAction): SearchState<any> => {

  switch (action.type) {

    case SearchStateActions.SET_FILTER: {
      return {
        ...state,
        filters: action.value
      };
    }

    case SearchStateActions.SET_CURRENT_LIST: {
      return {
        ...state,
        currentItems: action.value
      };

    }
    case SearchStateActions.SET_LIST: {
      return {
        ...state,
        initialItems: action.value
      };

    }
    case SearchStateActions.SET_CATEGORIES: {
      return {
        ...state,
        categories: action.value
      };

    }
    case SearchStateActions.SET_SELECTED_ITEM: {
      return {
        ...state,
        selectedItem: action.value
      };
    }
    case SearchStateActions.SHOW_DETAIL: {
      return {
        ...state,
        showDetail: action.value
      };
    }
    case SearchStateActions.RESET_STATE: {
      return {
        filters: {},
        currentItems: null,
        initialItems: null,
        categories: {},
        selectedItem: null,
        showDetail: false,
      };
    }
    case SearchStateActions.CLEAR_FILTER: {
      return {
        ...state,
        filters: {},
      };
    }

  }

  return state;

};


export const setCurrentList = (items: any[]) => {
  return {
    type: SearchStateActions.SET_CURRENT_LIST,
    value: items,
  }
};

export const setList = (items: any[]) => {
  return {
    type: SearchStateActions.SET_LIST,
    value: items,
  }
};

export const setFilter = (filters: Filters) => {
  return {
    type: SearchStateActions.SET_FILTER,
    value: filters,
  }
};

export const setCategories = (categories: { [key: string]: Category[] }) => {
  return {
    type: SearchStateActions.SET_CATEGORIES,
    value: categories,
  }
};


export const setSelectedItem = (item: any) => {
  return {
    type: SearchStateActions.SET_SELECTED_ITEM,
    value: item,
  }
};


export const setShowDetail = (show: boolean) => {
  return {
    type: SearchStateActions.SHOW_DETAIL,
    value: show,
  }
};

export const resetSearchState = () => {
  return {
    type: SearchStateActions.RESET_STATE,
  }
};

export const clearFilter = () => {
  return {
    type: SearchStateActions.CLEAR_FILTER,
  }
};
